module.exports = __webpack_public_path__ + "img/quarter.644f0cc5.png";